module.exports = __webpack_public_path__ + "static/media/carousal_3_mobile.67e83c97.jpg";